import React, { useMemo, useState } from 'react';
import styles from '../../../Tab.module.scss';
import { useRouteLoaderData } from 'react-router-dom';
import { ICustomer } from '../../../../model';
import { useFormOutletContext } from './CustomerInfo';
import { BillingSettingsSection } from '../../../../components/customer/Billing/Settings/BillingSettingsSection';
import {BillingMode} from "../../../../model/api/customers/billing-mode";
import {hasNexPark, hasNexResponse} from "../../../../model/api/nexParkInstance/instancesChecker";

const createSubLinks = (customer: ICustomer) => {
    const innerNavLinks = [
        { name: 'NexPark', enabled: hasNexPark(customer), disabled: false },
        { name: 'NexResponse', enabled: hasNexResponse(customer), disabled: false },
    ];

    return innerNavLinks.filter((link) => link.enabled);
};

const CustomerBillingSettingsTab = () => {
    const customer = useRouteLoaderData('customer-info') as ICustomer;
    const { hasBillingAccess } = useFormOutletContext();
    const dynamicSubNavLinks = useMemo(() => {
        return createSubLinks(customer);
    }, [customer]);
    const [activeInnerTab, setActiveInnerTab] = useState(dynamicSubNavLinks[0]?.name || 'NexPark');

    const renderInnerContent = () => {
        switch (activeInnerTab) {
            case 'NexPark':
                return <BillingSettingsSection customer={customer} hasBillingAccess={hasBillingAccess} billingMode={BillingMode.NexPark} />;
            case 'NexResponse':
                return <BillingSettingsSection customer={customer} hasBillingAccess={hasBillingAccess} billingMode={BillingMode.NexResponse} />;
            default:
                return <BillingSettingsSection customer={customer} hasBillingAccess={hasBillingAccess} billingMode={BillingMode.NexPark} />;
        }
    };

    return (
        <div className={styles.detailsLayout}>
            {dynamicSubNavLinks.length > 1 &&
                <nav className={styles.innerSidebar}>
                    <ul>
                        {dynamicSubNavLinks.map((tab) => (
                            <li key={tab.name}>
                                <button
                                    disabled={tab.disabled}
                                    type={'button'}
                                    className={activeInnerTab === tab.name ? styles.active : ''}
                                    onClick={() => setActiveInnerTab(tab.name)}
                                >
                                    {tab.name}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
            }

            <div className={styles.contentWrapper}>
                <h2 style={{ fontWeight: 400 }}>{activeInnerTab}</h2>
                {renderInnerContent()}
            </div>
        </div>
    );
};

export default CustomerBillingSettingsTab;
